module.exports = __webpack_public_path__ + "static/img/RiskInfo.4e259cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FFP/images/RiskInfo.png
// module id = iAL6
// module chunks = 0